import * as moment from "moment";
import {Message} from "@twilio/conversations";

export class ChatMessageManager{
  // private _all = new Array<ChatMemberAndUser>();
  private _messagePerChannelPerId = new Map<string,Map<string,Message>>();
  private _mapMessagePerChannelPerDate = new Map<string,Map<string,Message[]>>();



  addMessage(channelSid:string, msg:Message):boolean{
    if (!this._messagePerChannelPerId.has(channelSid)){
      this._messagePerChannelPerId.set(channelSid,new Map<string,Message>());
    }
    if (this._messagePerChannelPerId.get(channelSid).has(msg.sid)){
      // Message has been already added.
      return false;
    }
    this._messagePerChannelPerId.get(channelSid).set(msg.sid,msg);

    const key = moment(msg.dateCreated).format('ll');

    if (!this._mapMessagePerChannelPerDate.has(channelSid)){
      this._mapMessagePerChannelPerDate.set(channelSid,new Map<string,Message[]>());
    }
    if (!this._mapMessagePerChannelPerDate.get(channelSid).has(key)){
      this._mapMessagePerChannelPerDate.get(channelSid).set(key,new Array<Message>());
    }
    this._mapMessagePerChannelPerDate.get(channelSid).get(key).push(msg);

    return true;
  }


  removeMessage(channelSid:string, msg:Message){
    if (!this._messagePerChannelPerId.has(channelSid)){
      this._messagePerChannelPerId.set(channelSid,new Map<string,Message>());
    }
    if (this._messagePerChannelPerId.get(channelSid).has(msg.sid)){
      this._messagePerChannelPerId.get(channelSid).delete(msg.sid);
    }

    const key = moment(msg.dateCreated).format('ll');

    if (!this._mapMessagePerChannelPerDate.has(channelSid)){
      this._mapMessagePerChannelPerDate.set(channelSid,new Map<string,Message[]>());
    }
    if (!this._mapMessagePerChannelPerDate.get(channelSid).has(key)){
      this._mapMessagePerChannelPerDate.get(channelSid).set(key,new Array<Message>());
    }

    for (let idx =  this._mapMessagePerChannelPerDate.get(channelSid).get(key).length-1; idx>=0; idx--){
      const tmp = this._mapMessagePerChannelPerDate.get(channelSid).get(key)[idx];
      if (msg.sid === tmp.sid){
        this._mapMessagePerChannelPerDate.get(channelSid).get(key).splice(idx,1);
        break;
      }
    }

  }

  /**
   * Per date created!
   */
  public retrieveMessagePerDate(channelSid:string):Map<string,Message[]>{
    return this._mapMessagePerChannelPerDate.get(channelSid);
  }
}
